<template>
   <div class="crud-wrapper">
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState"
                    :title="modalTitle" @onCommand="toolbarCommand"
                    showBlock></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>
            <a-select-field :suggestions="workingStores" label="Empresa em que Trabalha" v-if="multiStore"
                            v-model="formData.companyId" validate="required"></a-select-field>

            <a-text-field autofocus label="Nome" text-transform="capitalize" v-model="formData.name"
                          validate="required"></a-text-field>

            <a-autocomplete-field allow-new autoTrigger label="Célula de Operação" obj="employeeCell"
                                  v-model="formData.cellId"></a-autocomplete-field>

            <a-text-field label="Fone" md4 v-mask="['(##) ####-####', '(##) #####-####']"
                          v-model="formData.mobileNumber"
                          validate="required"></a-text-field>
            <a-date-field :max="maxDate" dateFormat="DD/MM/YYYY" label="Nascimento" md4
                          v-model="formData.birth"></a-date-field>
            <a-text-field label="Ramal Voip" mask="####" md4 v-model="formData.voipExt"></a-text-field>

            <a-text-field label="Endereço" text-transform="capitalize" v-model="formData.address"></a-text-field>
            <a-text-field label="Cidade" md6 text-transform="capitalize" v-model="formData.city"></a-text-field>
            <a-text-field label="Estado" md3 text-transform="uppercase" v-model="formData.state"></a-text-field>
            <a-text-field label="CEP" mask="##.###-###" md3 v-model="formData.zipcode"></a-text-field>

         </v-layout>

         <template slot="rightContent">
            <v-tabs centered color="secondary" dark icons-and-text style="border-radius: 12px; margin-top: -8px">
               <v-tabs-slider color="white"></v-tabs-slider>

               <v-tab href="#tab-1">
                  Acesso ao Sistema
                  <v-icon>fas fa-key</v-icon>
               </v-tab>

               <v-tab href="#tab-2">
                  Esteiras Visíveis
                  <v-icon>fas fa-project-diagram</v-icon>
               </v-tab>

               <v-tab-item value="tab-1">
                  <v-card color="rgba(0,0,0, 0.03)" flat style="border-radius: 8px">
                     <!--<v-card-title class="pt-3 pb-4 title text-truncate text-no-wrap" primary-title>
                         Configurações de Acesso ao Sistema
                     </v-card-title>-->
                     <v-container>
                        <v-layout>
                           <v-flex pa-0 pa-2 xs3>
                              <v-card flat style="border-radius: 8px; margin-top: -5px;" >
                                 <v-img :aspect-ratio="idRatio" :src="media" style="border-radius: 8px"></v-img>

                                 <v-toolbar flat>
                                    <v-spacer></v-spacer>

                                    <v-tooltip bottom>
                                       <v-btn @click.stop="loadImgClick" color="primary" dark fab
                                              slot="activator"
                                              small>
                                          <v-icon small>fas fa-camera</v-icon>
                                       </v-btn>
                                       Carregar Foto
                                    </v-tooltip>

                                    <v-spacer></v-spacer>
                                 </v-toolbar>

                              </v-card>
                           </v-flex>
                           <v-flex pa-0 xs9>
                              <v-card-text class="pt-0">
                                 <a-text-field label="Usuário"
                                               v-model="formData.loginName"></a-text-field>

                                 <a-text-field hint="(será alterada no próx. acesso do usuário)" label="Senha Temporária"
                                               type="password"
                                               v-model="formData.firstPin"></a-text-field>

                                 <a-select-field label="Perfil" obj="role"
                                                 v-model="formData.roleId"
                                                 validate="required"></a-select-field>

                                 <a-select-field :suggestions="brandStores" label="Empresas que pode acessar"
                                                 multiple
                                                 v-if="multiStore" v-model="formData.allowedCompanies"
                                                 validate="required"></a-select-field>
                              </v-card-text>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card>
               </v-tab-item>

               <v-tab-item value="tab-2">
                  <v-card color="rgba(0,0,0, 0.03)" flat style="border-radius: 8px">

                     <v-card-text>
                        Restrinja as situações do Fluxo de Trabalho para este usuário. Caso nenhuma esteja selecionada,
                        ele poderá visualizar todas as situações de Propostas, Contrato e Comissões.
                     </v-card-text>
                     <v-card-text>
                        <a-select-field chips clearable deletable-chips label="Selecione Situações"
                                        multiple
                                        obj="contractStatus" v-model="formData.allowedStatus"></a-select-field>

                     </v-card-text>
                  </v-card>
               </v-tab-item>
            </v-tabs>


         </template>
      </crud-form>

   </div>


</template>

<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

    export default CrudFormClass.extend({
        name: 'EmployeeForm',

        data: function () {
            return {
                title: 'Usuário',
                formName: 'employeeForm',

                formData: {
                    id: null,
                    companyId: this.$store.state.company.selectedStore,
                    cellId: null,
                    name: null,
                    address: null,
                    city: null,
                    state: null,
                    zipcode: null,
                    mobileNumber: null,
                    voipId: null,
                    voipExt: null,
                    birth: null,
                    avatar: null,
                    blocked: 0,
                    loginName: null,
                    firstPin: null,
                    loginPin: null,
                    allowedCompanies: this.$store.state.company.brandStores[0].id,
                    allowedStatus: null,
                    roleId: 3
                }

            };
        },

        computed: {
            multiStore () {
                return this.$store.state.company.multiStore && !this.$store.state.company.isPartner;
            },

            brandStores () {
                return this.$store.state.company.brandStores;
            },

            isPartner () {
                return this.$store.state.company.isPartner;
            },

            workingStores () {
                return this.$store.state.company.brandStores.filter(f => f.id > 0);
            },

            idRatio () {
                let mediaRatio = 3 / 4;
                /*if (this.formData.avatar && this.formData.avatar.size && this.formData.avatar.size.h)
                   mediaRatio = (this.formData.avatar.size.w - 150) / this.formData.avatar.size.h;*/

                return mediaRatio;
            },

            media () {
                let media = '/static/images/no-avatar.jpg';

                if (this.formData.avatar) {
                    media = this.$config.imageUri(this.formData.avatar, 'photo');
                }

                return media;
            },

            maxDate () {
                return '2002-01-01';
            },
        },

        methods: {
            loadImgClick () {
                window.cloudinary.openUploadWidget(window.cloudinaryOptions.avatars, this.uploadedMedia);
            },

            uploadedMedia (error, result) {
                if (result && result.length) {
                    let res = result[0];
                    console.log(res);
                    this.formData.avatar = res.path || res.public_id;
                }
            }

        },

        mounted () {
            // console.log(this.modalMode, this.modalTitle);
        }

    });
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/pages/EmployeeForm.vue